import type {
  DashboardWidgetDefinitionCreateApiData,
  DashboardWidgetDefinitionCreateApiResponses,
  DashboardWidgetDefinitionDeleteApiData,
  DashboardWidgetDefinitionDeleteApiResponses,
  DashboardWidgetDefinitionGetApiData,
  DashboardWidgetDefinitionGetApiResponses,
  DashboardWidgetDefinitionListApiData,
  DashboardWidgetDefinitionListApiResponses,
  DashboardWidgetDefinitionPatchApiData,
  DashboardWidgetDefinitionPatchApiResponses,
  UserDashboardWidgetCreateApiData,
  UserDashboardWidgetCreateApiResponses,
  UserDashboardWidgetDeleteApiData,
  UserDashboardWidgetDeleteApiResponses,
  UserDashboardWidgetListApiData,
  UserDashboardWidgetListApiResponses,
  UserDashboardWidgetPatchApiData,
  UserDashboardWidgetPatchApiResponses,
  UserGroupFleetViewCarsListApiData,
  UserGroupFleetViewCarsListApiResponses,
  UserGroupFleetViewSummaryApiData,
  UserGroupFleetViewSummaryApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

// Dashboard

export const getDashboardUrls = {
  getUserDashboardWidgets: dataEndpoint<UserDashboardWidgetListApiData, UserDashboardWidgetListApiResponses>({
    getUrl: (queryParams) => apiUrl('dashboard/widgets/', queryParams)
  }),
  postCreateUserDashboardWidget: responseEndpoint<
    UserDashboardWidgetCreateApiData,
    UserDashboardWidgetCreateApiResponses
  >({
    getUrl: () => apiUrl('dashboard/widgets/'),
    getBody: (data) => data
  }),
  patchUserDashboardWidget: responseEndpoint<UserDashboardWidgetPatchApiData, UserDashboardWidgetPatchApiResponses>({
    getUrl: ({ widgetId }) => apiUrl(`dashboard/widgets/${widgetId}/`),
    getBody: (data) => data
  }),
  deleteUserDashboardWidget: dataEndpoint<UserDashboardWidgetDeleteApiData, UserDashboardWidgetDeleteApiResponses>({
    getUrl: ({ widgetId }) => apiUrl(`dashboard/widgets/${widgetId}/`)
  }),
  getDashboardWidgetDefinitions: dataEndpoint<
    DashboardWidgetDefinitionListApiData,
    DashboardWidgetDefinitionListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('dashboard/widget-definitions/', queryParams)
  }),
  getDashboardWidgetDefinition: dataEndpoint<
    DashboardWidgetDefinitionGetApiData,
    DashboardWidgetDefinitionGetApiResponses
  >({
    getUrl: ({ widgetDefinitionId }) => apiUrl(`dashboard/widget-definitions/${widgetDefinitionId}/`)
  }),
  postDashboardWidgetDefinition: responseEndpoint<
    DashboardWidgetDefinitionCreateApiData,
    DashboardWidgetDefinitionCreateApiResponses
  >({
    getUrl: () => apiUrl('dashboard/widget-definitions/'),
    getBody: (data) => data
  }),
  patchDashboardWidgetDefinition: responseEndpoint<
    DashboardWidgetDefinitionPatchApiData,
    DashboardWidgetDefinitionPatchApiResponses
  >({
    getUrl: ({ widgetDefinitionId }) => apiUrl(`dashboard/widget-definitions/${widgetDefinitionId}/`),
    getBody: (data) => data
  }),
  deleteDashboardWidgetDefinition: dataEndpoint<
    DashboardWidgetDefinitionDeleteApiData,
    DashboardWidgetDefinitionDeleteApiResponses
  >({
    getUrl: ({ widgetDefinitionId }) => apiUrl(`dashboard/widget-definitions/${widgetDefinitionId}/`)
  }),
  getPaginatedFleetViewCars: dataEndpoint<UserGroupFleetViewCarsListApiData, UserGroupFleetViewCarsListApiResponses>({
    getUrl: (queryParams) => apiUrl('fleet-view-cars/', queryParams)
  }),
  getFleetViewSummary: dataEndpoint<UserGroupFleetViewSummaryApiData, UserGroupFleetViewSummaryApiResponses>({
    getUrl: (queryParams) => apiUrl('fleet-view-summary/', queryParams)
  })
};
